import { FileSearchIcon } from 'lucide-react'

import { formatNumber } from '@/utils'

export const ScreeningProgress = ({ pages }: { pages: number }) => (
  <div
    aria-live="polite"
    className="flex flex-col items-center gap-4 rounded-lg border bg-muted/30 px-6 py-10 text-center"
  >
    <div className="relative h-12 w-12">
      <div className="absolute inset-0 animate-ping rounded-full bg-brand/10 [animation-duration:2s]" />
      <div className="relative flex h-12 w-12 items-center justify-center rounded-full bg-brand/10">
        <FileSearchIcon className="h-5 w-5 text-brand" />
      </div>
    </div>

    <div className="space-y-1">
      <p className="font-medium">Reading {formatNumber(pages)} pages</p>
      <p className="max-w-sm text-pretty text-muted-foreground text-sm">
        We're pulling out the filing date, case number, and what this case is
        likely to distribute. Results land here when it's done, and you can
        leave this page in the meantime.
      </p>
    </div>
  </div>
)
